(ns manage.adset-preview-page.view
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            ["react-use/lib/useMedia$default" :as useMedia]
            [common.modal.view :refer [defmodal modal]]
            [common.util :as util]
            [common.widgets.checkbox :refer [checkbox]]
            [common.widgets.content-function-version-selector :as cfn-version-selector]
            [common.widgets.input :refer [input]]
            [common.widgets.menu :refer [menu]]
            [common.widgets.overlay-page :as overlay-page]
            [manage.adset-preview-panel.view.core :refer [adset-preview-panel]]
            [manage.adset-preview-panel.view.notifications :refer [notifications]]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui header-actions []
  (let [logged-in? (use-subscribe [:resource.user/me])]
    ($ Stack {:direction "row" :alignItems "center" :gap 1}
       ($ cfn-version-selector/button-group
          {:on-change #(rf/dispatch [:adset-preview.content-function-version/activate-version %])})
       (when logged-in?
         ($ Button {:startIcon ($ Icon "share")
                    :variant "text"
                    :data-testid :share-button
                    :onClick #(rf/dispatch [:modal/open {:id :adset-preview-share-modal}])}
            "Share"))
       ($ menu
          {:icon "more_vert"
           :items [{:label "Add external template"
                    :on-click #(rf/dispatch [:ocp/open
                                             {:id :external-template/add}])}]}))))

(defmodal draft-missing :missing-content-modal
  []
  [modal
   {:title "Preview is currently unavailable"}
   [:div {:style {:p "1rem"}}
    [:a "It's likely that this preview has expired or we are encountering a problem with our system."]
    [:br]
    [:a "Please contact the person who shared this preview with you."]]])

(defmodal share-link :adset-preview-share-modal
  []
  (let [share-url @(rf/subscribe [:adset-preview.core/share-url])
        context-share @(rf/subscribe [:adset-preview.core/context-share])
        products-share @(rf/subscribe [:adset-preview.core/products-share])
        on-change-context #(rf/dispatch [:adset-preview.core/toggle-context-share])
        on-change-products #(rf/dispatch [:adset-preview.core/toggle-products-share])
        product-selectors @(rf/subscribe [:adset-preview.products/value :product-selectors])
        link-copied @(rf/subscribe [:adset-preview.core/value :link-copied])]
    [modal
     {:title "Share Preview"
      :footer ($ :<>
                 ($ Button {:onClick #(rf/dispatch [:modal/close])
                            :variant "text"} "Cancel")
                 ($ Button {:onClick #(rf/dispatch-sync [:adset-preview.core/copy-share-link share-url])
                            :variant "contained"}
                    "Copy link")
                 (when link-copied
                   ($ Icon {:color "success"
                            :sx #js {:ml 1}} "check")))}
     ($ Stack {}
        ($ checkbox
           {:label "Share current context"
            :on-change on-change-context
            :value context-share})
        (when (seq product-selectors)
          ($ checkbox
             {:label "Share current products (1st selector)"
              :on-change on-change-products
              :value products-share})))

     ($ Stack {:spacing 1}
        ($ :span "This is the link for sharing the preview page with current settings:")
        ($ input {:readOnly true :value share-url}))]))

(defui product-alerts []
  (let [expiry-date (use-subscribe [:adset-preview.core/expiry-date])
        expired? (< expiry-date (/ (.now js/Date) 1000))
        has-products-param (use-subscribe [:adset-preview.core/has-products-param])]
    (when has-products-param
      (if expired?
        ($ Alert {:severity "warning"}
           "Product functionalities have expired, please request a new link to re-enable them")
        ($ Alert {:severity "info"}
           (str "Product functionalities are active until "
                (util/format-timestamp expiry-date)
                ". Regular preview functionalities will continue to work after this date."))))))

(defui shared-adset-preview-page []
  (let [mobile? (useMedia "(max-width: 768px)")
        adset-name (use-subscribe [:adset-preview.core/value :adset-name])]
    ($ overlay-page/overlay-page
       ($ overlay-page/header {:title "Preview" :entity-name adset-name}
          ($ header-actions))
       ($ product-alerts)
       ($ notifications)
       (r/as-element [:f> adset-preview-panel mobile?]))))

(def adset-preview-page
  (uix/as-react
   (fn [{:keys [ref style onClose]}]
     (let [mobile? (useMedia "(max-width: 768px)")]
       (uix/use-effect (fn []
                         ;; The forward-events inside :page.content-configuration need
                         ;; to be destroyed, otherwise the preview page breaks.
                         (rf/dispatch [:page.content-configuration/destroy])
                         (fn []
                           ;; After closing the preview page, :page.content-configuration
                           ;; needs to re re-initialised.
                           (rf/dispatch [:page.content-configuration/init])))
                       [])
       ($ overlay-page/overlay-page {:ref ref :style style}
          ($ overlay-page/header {:title "Preview" :on-close onClose}
             ($ header-actions))
          ($ product-alerts)
          ($ notifications)
          (r/as-element [:f> adset-preview-panel mobile?]))))))
